/**
 * JavaScript file containing functions related to Localisation.
 *
 * @package 	simPRO
 * @subpackage  JavaScript
 * @category    JavaScript
 * @version 	2021-07-13 1.0
 * @author  	simPRO Software
 **/

const EUROPEAN_COUNTRIES = [
    'Austria',
    'Belgium',
    'Bulgaria',
    'Croatia',
    'Republic of Cyprus',
    'Czech Republic',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Greece',
    'Hungary',
    'Ireland',
    'Italy',
    'Latvia',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Netherlands',
    'Poland',
    'Portugal',
    'Romania',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Sweden'];
const EU_VAT_LOOKUP_URL = "http://ec.europa.eu/taxation_customs/vies/vieshome.do?selectedLanguage=EN";
const UK_VAT_LOOKUP_URL = "https://www.tax.service.gov.uk/check-vat-number/enter-vat-details";
const NZ_VAT_LOOKUP_URL = "http://www.business.govt.nz/companies/app/ui/pages/companies/search?mode=standard&type=entities&q=";
const AU_VAT_LOOKUP_URL = "https://www.abr.business.gov.au/Search/ResultsActive?SearchText=";

const COUNTRY_AUSTRALIA = "Australia";
const COUNTRY_UNITED_KINGDOM = "United Kingdom";
const COUNTRY_NEW_ZEALAND = "New Zealand";

function isEurope(country) {
    var result = false;
    $.each(EUROPEAN_COUNTRIES, function(index, value) {
        if (value.toLowerCase() === country) {
            result = true;
            return false;
        }
    });
    return result;
}

function getVatLookupURL(country, companyName) {
    let countryLower = country.toLowerCase();
    if (isEurope(countryLower)) {
        return EU_VAT_LOOKUP_URL;
    } else {
        switch (countryLower) {
        case COUNTRY_UNITED_KINGDOM.toLowerCase():
            return UK_VAT_LOOKUP_URL;
        case COUNTRY_NEW_ZEALAND.toLowerCase():
            return NZ_VAT_LOOKUP_URL + companyName;
        case COUNTRY_AUSTRALIA.toLowerCase():
            return AU_VAT_LOOKUP_URL + companyName;
        default:
            return false;
        }
    }
}

function getValidVatLookupURL(companyCountry, companyName = "") {
    var validVatLookupURL = getVatLookupURL(companyCountry, companyName);

    if (validVatLookupURL === false) {
        validVatLookupURL = getVatLookupURL(simPRODefaults.data("build-country"), companyName);
    }

    return validVatLookupURL;
}
